// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Container,
//   Typography,
//   Button,
//   Box,
//   Grid,
//   Paper,
//   Card,
//   CardContent,
//   Divider,
//   IconButton,
//   TableContainer,
//   TextField,
//   MenuItem,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate } from "react-router-dom";
// import Header2 from "../../Component/Header2";

// // ✅ Helper: Clean unwanted characters
// const cleanString = (str) =>
//   !str ? "" : str.replace(/[^\w\s\-\(\)&.,/₹]/g, "").replace(/\s+/g, " ").trim();

// // ✅ Format currency (Indian Rupees)
// const formatCurrency = (num) => {
//   if (!num || isNaN(num)) return "₹0";
//   const value = new Intl.NumberFormat("en-IN").format(num);
//   // Remove unwanted Unicode or invisible chars
//   return `₹ ${value.replace(/[^\d,]/g, '')}`;
// };

// const SalesReport = () => {
//   const [salesData, setSalesData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [filterProduct, setFilterProduct] = useState("");
//   const [minRevenue, setMinRevenue] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [reportType, setReportType] = useState("all");
//   const [exportFormat, setExportFormat] = useState("pdf");
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // ✅ Fetch data
//   useEffect(() => {
//     const userRole = localStorage.getItem("role");
//     const shopId = localStorage.getItem("shopkeeperID");
//     let endpoint = "https://sakhisshop.com/api/salesReport";

//     if (userRole === "shopkeeper" && shopId) {
//       endpoint += `?sID=${shopId}`;
//     }

//     setLoading(true);
//     axios
//       .get(endpoint)
//       .then((res) => {
//         const formatted = aggregateSales(res.data);
//         setSalesData(formatted);
//         setFilteredData(formatted);
//         setLoading(false);
//       })
//       .catch(() => {
//         setError("Failed to fetch sales data.");
//         setLoading(false);
//       });
//   }, []);

//   // ✅ Aggregate sales by product/date
//   // ✅ Aggregate sales by product/date
// const aggregateSales = (data) => {
//   const map = new Map();
//   data.forEach((item) => {
//     const dateKey = item.date ? item.date.split("T")[0] : "N/A";
//     const key = `${item.productName}-${dateKey}`;
//     if (!map.has(key)) {
//       map.set(key, {
//         productName: item.productName,
//         orderDate: item.date,
//         unit: item.uom || "N/A",
//         quantitySold: 0,
//         totalRevenue: 0,
//       });
//     }
//     const entry = map.get(key);
//     const qty = Number(item.quantitySold) || 0;
//     const revenue =
//       (Number(item.finalRevenue) || 0) * (Number(item.quantitySold) || 1); // ✅ Corrected line

//     entry.quantitySold += qty;
//     entry.totalRevenue += revenue;
//   });
//   return Array.from(map.values());
// };

//   // ✅ Aggregate monthly totals
//   const aggregateMonthlySales = (data) => {
//     const monthly = new Map();
//     data.forEach((item) => {
//       if (!item.orderDate) return;
//       const month = new Date(item.orderDate).toLocaleString("en-IN", {
//         month: "short",
//         year: "numeric",
//       });
//       if (!monthly.has(month)) {
//         monthly.set(month, { month, totalQty: 0, totalRevenue: 0 });
//       }
//       const m = monthly.get(month);
//       m.totalQty += Number(item.quantitySold) || 0;
//       m.totalRevenue += Number(item.totalRevenue) || 0;
//     });
//     return Array.from(monthly.values());
//   };

//   const handleFilter = () => {
//     let result = [...salesData];
//     if (filterProduct) {
//       result = result.filter((item) =>
//         cleanString(item.productName)
//           .toLowerCase()
//           .includes(filterProduct.toLowerCase())
//       );
//     }
//     if (minRevenue) {
//       const min = parseFloat(minRevenue);
//       if (!isNaN(min)) {
//         result = result.filter((item) => item.totalRevenue >= min);
//       }
//     }
//     setFilteredData(result);
//   };

//   if (loading)
//     return (
//       <Box sx={{ textAlign: "center", py: 10 }}>
//         <Typography>Loading...</Typography>
//       </Box>
//     );

//   if (error)
//     return (
//       <Box sx={{ textAlign: "center", py: 10, color: "red" }}>
//         <Typography>{error}</Typography>
//       </Box>
//     );

//   // ✅ Generate PDF
//   const generatePDF = (data, label) => {
//     const doc = new jsPDF();
//     const shopName = localStorage.getItem("shopName") || "Sakhis Shop";
//     doc.text(`${shopName} - ${label} Sales Report`, 14, 20);

//     const headers = ["Product", "Order Date", "Unit", "Revenue"];
//     const rows = data.map((i) => [
//       cleanString(i.productName),
//       i.orderDate
//         ? new Date(i.orderDate).toLocaleDateString("en-IN")
//         : "N/A",
//       cleanString(i.unit),
//       formatCurrency(i.totalRevenue),
//     ]);

//     const total = data.reduce(
//       (sum, i) => sum + (Number(i.totalRevenue) || 0),
//       0
//     );
//     rows.push(["Total", "", "", formatCurrency(total)]);

//     autoTable(doc, {
//       startY: 30,
//       head: [headers],
//       body: rows,
//       theme: "striped",
//       headStyles: { fillColor: [25, 118, 210], textColor: 255 },
//       bodyStyles: { fontSize: 10 },
//     });

//     doc.save(`${label}-SalesReport.pdf`);
//   };

//   // ✅ Excel Export
//   const generateExcel = (data, label) => {
//     const headers = ["Product", "Order Date", "Unit", "Revenue (₹)"];
//     const rows = data.map((i) => [
//       cleanString(i.productName),
//       i.orderDate
//         ? new Date(i.orderDate).toLocaleDateString("en-IN")
//         : "N/A",
//       cleanString(i.unit),
//       formatCurrency(i.totalRevenue),
//     ]);
//     const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, sheet, "SalesReport");
//     XLSX.writeFile(wb, `${label}-SalesReport.xlsx`);
//   };

//   const filterByReportType = () => {
//     const today = new Date();
//     if (reportType === "all") return filteredData;

//     return filteredData.filter((item) => {
//       if (!item.orderDate) return false;
//       const date = new Date(item.orderDate);
//       if (reportType === "daily")
//         return date.toDateString() === today.toDateString();
//       if (reportType === "weekly") {
//         const weekAgo = new Date(today);
//         weekAgo.setDate(today.getDate() - 7);
//         return date >= weekAgo && date <= today;
//       }
//       if (reportType === "monthly")
//         return (
//           date.getMonth() === today.getMonth() &&
//           date.getFullYear() === today.getFullYear()
//         );
//       return true;
//     });
//   };

//   const handleExport = () => {
//     const data = filterByReportType();
//     const label =
//       reportType.charAt(0).toUpperCase() + reportType.slice(1);
//     if (exportFormat === "pdf") generatePDF(data, label);
//     else generateExcel(data, label);
//   };

//   return (
//     <Box sx={{ backgroundColor: "#f4f6f8", minHeight: "100vh", py: 3 }}>
//       <Header2 />
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Box sx={{ pt: { xs: 10, sm: 12 }, px: { xs: 2, sm: 4 } }}
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//           flexWrap="wrap"
//           mb={3}
//         >
//           <Box display="flex" alignItems="center" mb={{ xs: 1, sm: 0,p:7 }}>
//             <IconButton onClick={() => navigate(-1)} color="primary" sx={{ mr: 1 }}>
//               <ArrowBackIosNewIcon fontSize="small" />
//             </IconButton>
//             <Typography variant="h6" fontWeight="bold" color="primary">
//               🛒 Sales Performance Report
//             </Typography>
//           </Box>
//         </Box>

//         {/* Filters */}
//         <Card elevation={3} sx={{ borderRadius: 2, mb: 3 }}>
//           <CardContent>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6} md={5}>
//                 <TextField
//                   label="Search Product"
//                   variant="outlined"
//                   fullWidth
//                   size="small"
//                   value={filterProduct}
//                   onChange={(e) => setFilterProduct(e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={4} md={4}>
//                 <TextField
//                   label="Min Revenue (₹)"
//                   variant="outlined"
//                   type="number"
//                   fullWidth
//                   size="small"
//                   value={minRevenue}
//                   onChange={(e) => setMinRevenue(e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={2} md={3}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   sx={{ height: "100%" }}
//                   onClick={handleFilter}
//                 >
//                   Filter
//                 </Button>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Export Controls */}
//         <Grid container spacing={2} mb={2}>
//           <Grid item xs={12} sm={6} md={4}>
//             <TextField
//               select
//               label="Report Type"
//               value={reportType}
//               onChange={(e) => setReportType(e.target.value)}
//               fullWidth
//               size="small"
//             >
//               <MenuItem value="daily">Daily</MenuItem>
//               <MenuItem value="weekly">Weekly</MenuItem>
//               <MenuItem value="monthly">Monthly</MenuItem>
//               <MenuItem value="all">All</MenuItem>
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={6} md={4}>
//             <TextField
//               select
//               label="Export Format"
//               value={exportFormat}
//               onChange={(e) => setExportFormat(e.target.value)}
//               fullWidth
//               size="small"
//             >
//               <MenuItem value="pdf">PDF</MenuItem>
//               <MenuItem value="excel">Excel</MenuItem>
//             </TextField>
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Button
//               variant="contained"
//               color="primary"
//               fullWidth
//               sx={{ height: "100%" }}
//               onClick={handleExport}
//             >
//               Export
//             </Button>
//           </Grid>
//         </Grid>

//         {/* Sales Table */}
//         <Card elevation={3} sx={{ borderRadius: 2 }}>
//           <TableContainer
//             component={Paper}
//             sx={{
//               maxHeight: { xs: 300, sm: 400 },
//               borderRadius: 2,
//               overflowX: "auto",
//             }}
//           >
//             <Typography
//   variant="caption"
//   sx={{ mt: 1, display: "block", textAlign: "right", color: "gray" }}
// >
//   *Revenue shown is based on the selected report period.
// </Typography>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow>
//                   {["Product", "Order Date", "Unit", "Revenue (₹)"].map(
//                     (h, i) => (
//                       <TableCell
//                         key={i}
//                         sx={{
//                           backgroundColor: "#1976d2",
//                           color: "#fff",
//                           fontWeight: "bold",
//                           fontSize: "0.85rem",
//                         }}
//                       >
//                         {h}
//                       </TableCell>
//                     )
//                   )}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredData.length ? (
//                   <>
//                     {filteredData.map((item, idx) => (
//                       <TableRow key={idx} hover>
//                         <TableCell sx={{ fontSize: "0.8rem" }}>
//                           {cleanString(item.productName)}
//                         </TableCell>
//                         <TableCell sx={{ fontSize: "0.8rem" }}>
//                           {item.orderDate
//                             ? new Date(
//                                 item.orderDate
//                               ).toLocaleDateString("en-IN")
//                             : "N/A"}
//                         </TableCell>
//                         <TableCell sx={{ fontSize: "0.8rem" }}>
//                           {cleanString(item.unit)}
//                         </TableCell>
//                         <TableCell
//                           align="right"
//                           sx={{ fontSize: "0.8rem" }}
//                         >
//                           {formatCurrency(item.totalRevenue)}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                     <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
//                      <TableCell colSpan={3} sx={{ fontWeight: "bold", fontSize: "0.85rem" }}>
//                       Grand Total (Selected Period)
//                     </TableCell>
//                       <TableCell
//                         align="right"
//                         sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
//                       >
//                         {formatCurrency(
//   filterByReportType().reduce(
//     (a, i) => a + (Number(i.totalRevenue) || 0),
//     0
//   ).toFixed(2)
// )}
//                       </TableCell>
//                     </TableRow>
//                   </>
//                 ) : (
//                   <TableRow>
//                     <TableCell
//                       colSpan={4}
//                       align="center"
//                       sx={{ py: 3, fontSize: "0.8rem" }}
//                     >
//                       No records found.
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Card>
//       </Container>
//     </Box>
//   );
// };

// export default SalesReport;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import Header2 from "../../Component/Header2";

// ======= Helpers =======
const cleanString = (str) =>
  str ? str.replace(/[^\w\s\-\(\)&.,/₹]/g, "").trim() : "";

const formatCurrency = (num) => {
  if (!num || isNaN(num)) return "₹0";
  return "₹ " + new Intl.NumberFormat("en-IN").format(num);
};

// ======= SalesReport Component =======
const SalesReport = () => {
  const [salesData, setSalesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterProduct, setFilterProduct] = useState("");
  const [minRevenue, setMinRevenue] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportType, setReportType] = useState("all");
  const [exportFormat, setExportFormat] = useState("pdf");

  const navigate = useNavigate();

  // ======= Fetch Data =======
  // useEffect(() => {
  //   const userRole = localStorage.getItem("role");
  //   const shopId = localStorage.getItem("shopkeeperID");
  //   let endpoint = "https://sakhisshop.com/api/salesReport";

  //   if (userRole === "shopkeeper" && shopId) {
  //     endpoint += `?sID=${shopId}`;
  //   }

  //   setLoading(true);
  //   axios
  //     .get(endpoint)
  //     .then((res) => {
  //       const formatted = aggregateSales(res.data);
  //       setSalesData(formatted);
  //       setFilteredData(formatted);
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setError("Failed to fetch sales data.");
  //       setLoading(false);
  //     });
  // }, []);

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    const shopId = localStorage.getItem("shopkeeperID");

    let endpoint = "https://sakhisshop.com/api/salesReport";

    if (userRole && userRole.toLowerCase() === "shopkeeper" && shopId) {
      endpoint += `?sID=${shopId}`;
    }

    console.log("✅ Final endpoint:", endpoint);

    setLoading(true);

    axios
      .get(endpoint)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const formatted = aggregateSales(res.data);
          setSalesData(formatted);
          setFilteredData(formatted);
        } else {
          console.warn("Unexpected response format:", res.data);
          setSalesData([]);
          setFilteredData([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching sales data:", err);
        setError("Failed to fetch sales data.");
        setLoading(false);
      });
  }, []);

  // ======= Aggregate Sales =======
  const aggregateSales = (data) => {
    const map = new Map();
    data.forEach((item) => {
      const dateKey = item.date ? item.date.split("T")[0] : "N/A";
      const key = `${item.productName}-${dateKey}`;

      if (!map.has(key)) {
        map.set(key, {
          productName: item.productName,
          orderDate: dateKey,
          unit: item.uom || "N/A",
          quantitySold: 0,
          totalRevenue: 0,
        });
      }

      const entry = map.get(key);
      const qty = Number(item.quantitySold) || 0;
      const revenue = Number(item.finalRevenue) || 0;

      entry.quantitySold += qty;
      entry.totalRevenue += revenue;
    });

    return Array.from(map.values());
  };

  // ======= Filter Logic =======
  const handleFilter = () => {
    let result = [...salesData];
    if (filterProduct) {
      result = result.filter((item) =>
        cleanString(item.productName)
          .toLowerCase()
          .includes(filterProduct.toLowerCase()),
      );
    }
    if (minRevenue) {
      const min = parseFloat(minRevenue);
      if (!isNaN(min)) result = result.filter((i) => i.totalRevenue >= min);
    }
    setFilteredData(result);
  };

  // ======= Filter by Report Type =======
  const filterByReportType = () => {
    const today = new Date();
    if (reportType === "all") return filteredData;

    return filteredData.filter((item) => {
      if (!item.orderDate || item.orderDate === "N/A") return false;
      const date = new Date(item.orderDate);
      if (reportType === "daily")
        return date.toDateString() === today.toDateString();
      if (reportType === "weekly") {
        const weekAgo = new Date(today);
        weekAgo.setDate(today.getDate() - 7);
        return date >= weekAgo && date <= today;
      }
      if (reportType === "monthly")
        return (
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear()
        );
      return true;
    });
  };

  // ======= Export Functions =======
  const generatePDF = (data, label) => {
    const doc = new jsPDF();
    const shopName = localStorage.getItem("shopName") || "Sakhis Shop";
    doc.text(`${shopName} - ${label} Sales Report`, 14, 20);

    // Only show same columns as table
    const headers = ["#", "Product", "Order Date", "Unit", "Revenue"];

    const rows = data.map((i, idx) => [
      idx + 1,
      cleanString(i.productName),
      i.orderDate || "N/A",
      cleanString(i.unit),
      formatCurrency(i.totalRevenue ?? 0),
    ]);

    // Grand Total calculation
    const grandTotal = data.reduce(
      (sum, i) => sum + Number(i.totalRevenue ?? 0),
      0,
    );
    rows.push(["", "", "", "Grand Total", formatCurrency(grandTotal)]);

    autoTable(doc, {
      startY: 30,
      head: [headers],
      body: rows,
      theme: "grid",
      headStyles: { fillColor: [25, 118, 210], textColor: 255 },
      bodyStyles: { fontSize: 9 },
    });

    doc.save(`${label}-SalesReport.pdf`);
  };

  const generateExcel = (data, label) => {
    const headers = ["Product", "Order Date", "Unit", "Revenue (₹)"];
    const rows = data.map((i) => [
      cleanString(i.productName),
      i.orderDate || "N/A",
      cleanString(i.unit),
      i.totalRevenue ?? 0,
    ]);

    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SalesReport");
    XLSX.writeFile(wb, `${label}-SalesReport.xlsx`);
  };

  const handleExport = () => {
    const data = filterByReportType();
    const label = reportType.charAt(0).toUpperCase() + reportType.slice(1);
    exportFormat === "pdf"
      ? generatePDF(data, label)
      : generateExcel(data, label);
  };

  // ======= Loading/Error UI =======
  if (loading)
    return (
      <Box sx={{ py: 10, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );

  if (error)
    return (
      <Box sx={{ py: 10, textAlign: "center", color: "red" }}>
        <Typography>{error}</Typography>
      </Box>
    );

  const displayedData = filterByReportType();
  const grandTotal = displayedData.reduce(
    (sum, i) => sum + Number(i.totalRevenue || 0),
    0,
  );

  // ======= Render =======
  return (
    <Box sx={{ backgroundColor: "#f4f6f8", minHeight: "100vh", py: 3 }}>
      <Header2 />
      <Container maxWidth="lg">
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Box display="flex" alignItems="center">
            <IconButton onClick={() => navigate(-1)} color="primary">
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
            <Typography variant="h6" fontWeight="bold" color="primary">
              🛒 Sales Performance Report
            </Typography>
          </Box>
        </Box>

        {/* Filters */}
        <Card sx={{ borderRadius: 2, mb: 3 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={5}>
                <TextField
                  label="Search Product"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={filterProduct}
                  onChange={(e) => setFilterProduct(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <TextField
                  label="Min Revenue (₹)"
                  type="number"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={minRevenue}
                  onChange={(e) => setMinRevenue(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={3}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ height: "100%" }}
                  onClick={handleFilter}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Export Controls */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              label="Report Type"
              fullWidth
              size="small"
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <MenuItem value="daily">Daily</MenuItem>
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="all">All</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              label="Export Format"
              fullWidth
              size="small"
              value={exportFormat}
              onChange={(e) => setExportFormat(e.target.value)}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="excel">Excel</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ height: "100%" }}
              onClick={handleExport}
            >
              Export
            </Button>
          </Grid>
        </Grid>

        {/* Sales Table */}
        <Card sx={{ borderRadius: 2 }}>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: 400, overflowX: "auto", borderRadius: 2 }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {["Product", "Order Date", "Unit", "Revenue"].map(
                    (h, idx) => (
                      <TableCell
                        key={idx}
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                        }}
                      >
                        {h}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedData.length ? (
                  <>
                    {displayedData.map((item, idx) => (
                      <TableRow key={idx} hover>
                        <TableCell sx={{ fontSize: "0.8rem" }}>
                          {cleanString(item.productName)}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.8rem" }}>
                          {item.orderDate}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.8rem" }}>
                          {cleanString(item.unit)}
                        </TableCell>
                        <TableCell align="right" sx={{ fontSize: "0.8rem" }}>
                          {formatCurrency(item.totalRevenue)}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                      <TableCell
                        colSpan={3}
                        sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
                      >
                        Grand Total
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
                      >
                        {formatCurrency(grandTotal.toFixed(2))}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{ py: 3, fontSize: "0.8rem" }}
                    >
                      No records found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Typography
              variant="caption"
              sx={{ p: 1, display: "block", textAlign: "right", color: "gray" }}
            >
              *Revenue shown is based on the selected report period.
            </Typography>
          </TableContainer>
        </Card>
      </Container>
    </Box>
  );
};

export default SalesReport;
